//import { config } from '@/config';
import * as Firebase from 'firebase/app';

if (process.env.VUE_APP_DATA === 'firebase') {
  //const firebaseKey = process.env.NODE_ENV!;
  //const firebaseConfig = config.firebaseConfig[firebaseKey];
  const firebaseConfig = {
    apiKey: process.env.VUE_APP_FIREBASE_API_KEY,
    authDomain: process.env.VUE_APP_FIREBASE_AUTH_DOMAIN,
    databaseURL: process.env.VUE_APP_FIREBASE_DATABASE_URL,
    projectId: process.env.VUE_APP_FIREBASE_PROJECT_ID,
    storageBucket: process.env.VUE_APP_FIREBASE_STORAGE_BUCKET,
    messagingSenderId: process.env.VUE_APP_FIREBASE_MESSAGING_SENDER_ID,
    appId: process.env.VUE_APP_FIREBASE_APP_ID
  };

  console.log('Firebase.initializeApp ' + JSON.stringify(firebaseConfig));
  Firebase.initializeApp(firebaseConfig);
}

export const FirebaseDependency = Firebase;
